import { getDialogContentStyles } from './DialogContentStyles.js';
import { clsx } from 'clsx';
import { jsx } from '@emotion/react/jsx-runtime';

const DialogContent = _ref => {
  let {
    children,
    className,
    ...rest
  } = _ref;
  return jsx("div", {
    css: getDialogContentStyles,
    className: clsx('dialog-content', className),
    ...rest,
    children: children
  });
};

export { DialogContent };
//# sourceMappingURL=DialogContent.js.map
